import * as React from "react";

function SvgIcSChevronRight(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.293 7.293a1 1 0 011.414 0L15 10.586a2 2 0 010 2.828l-3.293 3.293a1 1 0 01-1.414-1.414L13.586 12l-3.293-3.293a1 1 0 010-1.414z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgIcSChevronRight;
